import axios from "axios";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import PsContext from "../../../context";

import { NEW_GIF } from "../../../utils/data";
import { ServiceUrl } from "../../../utils/serviceUrl";

const TopHeader = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    listData();
  }, []);

  const listData = () => {
    setLoader(true);
    axios
      .get(ServiceUrl.LIST_PAGES + "?type=announcement&upcoming=1&top_scroll=1")
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        }
        setLoader(false);
      });
  };

  const marqueeMouseOver = () => {
    document.getElementById("adm_top_marquee__2").stop();
  };

  const marqueeMouseOut = () => {
    document.getElementById("adm_top_marquee__2").start();
  };

  return (
    <div className="ed-top">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="ed-com-t1-left text-white">
              <ul>
                <li>
                  <a href="javascript:;" className="text-white">
                    Admission Enquiry
                  </a>
                </li>
                <li>
                  <a href="javascript:;" className="text-white">
                    Phone: {context.settingValue("enquiry_phone")}
                  </a>
                </li>
              </ul>
            </div>
            <div className="ed-com-t1-right" style={{ width: "50%" }}>
              <marquee
                className="text-white"
                onMouseOver={(e) => marqueeMouseOver()}
                onMouseOut={(e) => marqueeMouseOut()}
                id="adm_top_marquee__2"
              >
                {dataList.map((item, i) => {
                  return (
                    <span>
                      {item.show_new_blink_img == "1" && (
                        <img src={NEW_GIF.default} style={{ width: "55px" }} />
                      )}
                      {item.seo_slug && item.seo_slug.length > 4 ? (
                        <a
                          href={item.seo_slug}
                          target="_blank"
                          style={{ color: "#fff" }}
                        >
                          {item.title}
                        </a>
                      ) : (
                        item.title
                      )}
                    </span>
                  );
                })}
              </marquee>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
